import moment from 'moment'

const MEETING_HEADERS = [
  'agentId',
  'agentName',
  'agentEmail',
  'endUserId',
  'endUserName',
  'endUserEmail',
  'companyName',
  'jobTitle',
  'createdDate',
  'meetingStartDate',
  'duration',
  'meetingSource',
  'status',
]

const mapToRow = (meeting, header) => {
  switch (header) {
    case 'endUserName':
      return meeting.endUser.name
    case 'endUserEmail':
      return meeting.endUser.email
    case 'companyName':
      return meeting.endUser.company
    case 'jobTitle':
      return meeting.endUser.title
    case 'createdDate':
      return moment(meeting.createdAt).toISOString()
    case 'meetingStartDate':
      return moment(meeting.meetingStartAt).toISOString()
    case 'duration':
      return meeting.durationMillis
    case 'meetingSource':
      return meeting.meetingSource
    default:
      return meeting[header]
  }
}

const sanitizeString = (str?: string) => {
  return typeof str === 'string' && str.includes(',') ? `"${str}"` : str
}

export const toCSV = (data) => {
  const response = [MEETING_HEADERS.join(',')]

  data.forEach((meeting) => {
    const row = MEETING_HEADERS.map((header) =>
      sanitizeString(mapToRow(meeting, header))
    )
    response.push(row.join(','))
  })
  return response.join('\n')
}
